import { hasPermission } from './Permissions';

export function hasClaimsPermission(permission) {
    return hasPermission(permission);
}

export function hasAnyClaimsMenuAccess() {
    return [
        'claims.videos.view',
        'claims.testimonials.view',
        'claims.testimonials.create',
        'claims.records.view',
        'claims.records.create',
    ].some((name) => hasClaimsPermission(name));
}
